export default __webpack_public_path__ + "static/media/NaharTime.a5095460.eot";